import {FieldInput, FormSection} from "../../../ui";
import {AccountingConfigurationDto} from "../../../../api/cms";

interface CmsAccountingConfigurationFormData {
    accountingConfiguration: AccountingConfigurationDto
}

export interface CmsAccountingConfigurationFormHelp {
    vkOrg?: string,
    vkBur?: string
}

interface CmsAccountingConfigurationFormProps {
    value: CmsAccountingConfigurationFormData
    onChange: (value: CmsAccountingConfigurationFormData) => any
    validate: () => Promise<any>
    saving: boolean
    help: CmsAccountingConfigurationFormHelp
}

const CmsAccountingConfigurationForm = function CmsAccountingConfigurationForm({
                                                                                   value,
                                                                                   saving,
                                                                                   onChange,
                                                                                   validate,
                                                                                   help
                                                                               }: CmsAccountingConfigurationFormProps) {

    return <FormSection
        label={"Abrechnung"}>
        <>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"VKORG"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(help.vkOrg)}
                        help={help.vkOrg}
                        value={value.accountingConfiguration.vkOrg}
                        onBlur={async () => await validate()}
                        maxLength={4}
                        onChange={vkOrg => {
                            onChange({
                                ...value,
                                accountingConfiguration: {
                                    ...value.accountingConfiguration,
                                    vkOrg: vkOrg
                                }
                            })
                        }}
                    />
                </div>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"VKBUR"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(help.vkBur)}
                        help={help.vkBur}
                        value={value.accountingConfiguration.vkBur}
                        onBlur={async () => await validate()}
                        onChange={vkBur => {
                            onChange({
                                ...value,
                                accountingConfiguration: {
                                    ...value.accountingConfiguration,
                                    vkBur: vkBur
                                }
                            })
                        }}
                    />
                </div>
            </div>
        </>
    </FormSection>
}

export {
    CmsAccountingConfigurationForm
}
